import React from 'react';
import { Select as ChakraSelect, SelectProps as ChakraSelectProps } from '@chakra-ui/react';

export function Select(props: ChakraSelectProps) {
  return <ChakraSelect {...props} />;
}
